(() => {
  'use strict';
  const sky=document.querySelector('[data-sky]'),button=document.querySelector('[data-sky-toggle]'),mascot=document.querySelector('[data-menu-mascot]');
  if(!button)return;
  const mew=document.querySelector('[data-sky-mew]'),mewAnimated=mew?.getAttribute('src');
  const sprite=mascot?.querySelector('[data-mascot-sprite]'),reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused=false,frameRequest=0,lastTime=0,elapsed=0,distance=0,spriteState='';
  try{paused=localStorage.getItem('yg-background-paused')==='true';}catch{}
  const canWalk=()=>sprite&&!paused&&!reduced.matches&&!document.hidden&&!mascot.hidden;
  const paint=()=>{
    const compact=window.matchMedia('(max-width:1000px)').matches;
    const cycle=compact?14:24;
    const phase=(elapsed/1000)%cycle;
    const outStart=compact?3:4,outEnd=compact?5:11,backStart=compact?9:16,backEnd=compact?11:23;
    let x=-distance,state='idle',row=0,frame=0;
    if(distance>0&&phase>=outStart&&phase<outEnd){state='walk';row=2;x=-distance+distance*2*(phase-outStart)/(outEnd-outStart);}
    else if(phase>=outEnd&&phase<backStart)x=distance;
    else if(distance>0&&phase>=backStart&&phase<backEnd){state='walk';row=6;x=distance-distance*2*(phase-backStart)/(backEnd-backStart);}
    if(state==='walk'){
      const tick=Math.floor(elapsed*60/1000)%36;
      frame=tick<8?0:tick<18?1:tick<26?2:3;
    }else{
      const idleSeconds=phase<outStart?(elapsed>=cycle*1000?phase+cycle-backEnd:phase):phase>=backEnd?phase-backEnd:phase-outEnd;
      const tick=Math.floor(idleSeconds*60),hop=tick%53;
      frame=tick>=106?0:hop<40?0:hop<42?1:hop<45?2:hop<48?3:hop<51?4:5;
    }
    sprite.style.position='relative';
    sprite.style.left=(state==='idle'?-11:row===2?6:-6)+'px';
    sprite.style.top=(state==='idle'?-16:0)+'px';
    if(state!==spriteState){sprite.style.backgroundImage='url('+JSON.stringify(mascot.dataset[state==='walk'?'mascotWalk':'mascotIdle'])+')';spriteState=state;}
    sprite.style.backgroundPosition=(-frame*(state==='walk'?64:80))+'px '+(-row*80)+'px';
    sprite.parentElement.style.transform='translateX('+x.toFixed(2)+'px)';
    mascot.dataset.mascotState=state;
  };
  const animate=time=>{
    frameRequest=0;if(!canWalk()){lastTime=0;return;}
    if(lastTime)elapsed+=time-lastTime;lastTime=time;paint();frameRequest=requestAnimationFrame(animate);
  };
  const sync=()=>{
    const stopped=paused||reduced.matches||document.hidden;sky?.classList.toggle('is-paused',stopped);document.body.classList.toggle('yg-effects-paused',stopped);button.hidden=reduced.matches||(!sky&&(!mascot||mascot.hidden));
    if(mew){const source=stopped?mew.dataset.mewStatic:mewAnimated;if(source&&mew.getAttribute('src')!==source)mew.setAttribute('src',source);}
    button.setAttribute('aria-pressed',String(!paused));button.setAttribute('aria-label',paused?window.YugenI18n.t('j_17258ddec8'):window.YugenI18n.t('j_f83494af79'));
    button.querySelector('[data-sky-toggle-label]').textContent=paused?window.YugenI18n.t('j_e62387050f'):window.YugenI18n.t('j_349292b5c4');
    if(canWalk()){if(!frameRequest)frameRequest=requestAnimationFrame(animate);}
    else{cancelAnimationFrame(frameRequest);frameRequest=0;lastTime=0;}
  };
  button.addEventListener('click',()=>{paused=!paused;try{localStorage.setItem('yg-background-paused',String(paused));}catch{}sync();});
  reduced.addEventListener('change',sync);document.addEventListener('visibilitychange',sync);
  if(mascot){
    const nav=mascot.closest('nav'),primary=nav.querySelector('.yg-nav-primary'),links=[...primary.querySelectorAll('a')],menu=nav.querySelector('.yg-universe-menu'),main=nav.closest('header').querySelector('.yg-header-main');
    const setLane=(parent,left,width,lane)=>{
      if(mascot.parentElement!==parent)parent.append(mascot);
      mascot.hidden=false;mascot.dataset.mascotLane=lane;
      mascot.style.setProperty('--mascot-left',left+'px');mascot.style.setProperty('--mascot-width',width+'px');
      mascot.style.left=left+'px';mascot.style.width=width+'px';
      const scale=parseFloat(getComputedStyle(sprite.parentElement).scale)||1;
      distance=lane==='header'?Math.max(0,(width-40*scale-4)/(2*scale)):Math.min(110,Math.max(0,(width-64)/2));
      paint();sync();
    };
    const place=()=>{
      if(!links.length||!menu||!main)return;
      const compact=window.matchMedia('(max-width:1000px)').matches;
      if(mascot.parentElement!==nav)primary.after(mascot);
      const bounds=nav.getBoundingClientRect(),last=links[links.length-1].getBoundingClientRect(),menuBounds=menu.getBoundingClientRect();
      if(window.matchMedia('(max-width:700px)').matches){
        const box=main.getBoundingClientRect(),logo=main.querySelector('.yg-logo').getBoundingClientRect(),actions=main.querySelector('.yg-header-actions').getBoundingClientRect();
        setLane(main,logo.right-box.left+2,Math.max(16,actions.left-logo.right-4),'header');return;
      }
      const start=last.right-bounds.left+18,end=(menuBounds.width?menuBounds.left-bounds.left-18:bounds.width-8),gap=end-start;
      if(gap>=70){setLane(nav,start,gap,'nav');return;}
      if(compact){
        const box=main.getBoundingClientRect(),logo=main.querySelector('.yg-logo').getBoundingClientRect(),actions=main.querySelector('.yg-header-actions').getBoundingClientRect();
        const available=actions.left-logo.right-8;
        if(available>=32){setLane(main,logo.right-box.left+4,available,'header');return;}
      }
      mascot.hidden=true;sync();
    };
    const observer=new ResizeObserver(place);observer.observe(nav);observer.observe(menu);observer.observe(main);links.forEach(link=>observer.observe(link));document.fonts?.ready.then(place);place();
  }
  sync();
})();






